export default __webpack_public_path__ + "static/media/led2_up_overlay.3606dc65.svg";